import React from 'react';
import PropTypes from 'prop-types';
import { NavItem, NavLink } from 'reactstrap';
import { FrenchFlag, EnglishFlag } from './FlagIcon';

const ChangeLang = ({ langChange, toggleSmallMenu, locale }) => {
  return (
    <NavItem>
      <NavLink
        onClick={() => {
          langChange(locale === 'fr' ? 'en' : 'fr');
          toggleSmallMenu();
        }}
      >
        {locale === 'fr' ? <EnglishFlag /> : <FrenchFlag />}
      </NavLink>
    </NavItem>
  );
};

ChangeLang.propTypes = {
  langChange: PropTypes.func.isRequired,
  toggleSmallMenu: PropTypes.func,
  locale: PropTypes.string.isRequired,
};

export default ChangeLang;



// WEBPACK FOOTER //
// ./src/components/Header/ChangeLang.js